import { Transform, Type } from 'class-transformer';
import {
	calendarDateTransformer,
	dateTransformer,
} from 'src/lib/utilities/api/class-transformer-types';
import {
	StudentWithdrawRequestModel,
	StudentWithdrawRequestModel_ClassTransformType,
} from '../enrollment/student-withdraw.model';
import {
	StudentPauseRequestModel,
	StudentPauseRequestModel_ClassTransform_Type,
} from '../pause/students-pause.model';

export enum GraduationReviewStatus {
	Unchecked = 2,
	ReviewRequested = 1,
	VerificationRequested = 9,
	MissingGraduationRequirements = 3,
	WaitingOnProgram = 4,
	WaitingOnStudent = 5,
	NeedsTesting = 8,
	GraduationRequestRejected = 7,
	GraduationRequestSubmitted = 10,
	GraduationRequestAuthorized = 6,
	GraduationRequestApproved = 12,
	Graduated = 11,
}

export class GraduationReviewOptionModel {
	key: GraduationReviewStatus;
	title: string;
}

export function GraduationReviewOptionModel_ClassTransformType() {
	return GraduationReviewOptionModel;
}

export class GraduationReviewUpdateReasonsModel {
	'3': {
		key: string;
		title: string;
	}[];
}

export function GraduationReviewUpdateReasonsModel_ClassTransformType() {
	return GraduationReviewUpdateReasonsModel;
}

export class GraduationReviewOptionResponseModel {
	success: boolean;
	@Type(GraduationReviewOptionModel_ClassTransformType)
	checklist_fields: GraduationReviewOptionModel[];
	@Type(GraduationReviewOptionModel_ClassTransformType)
	status: GraduationReviewOptionModel[];
	@Type(GraduationReviewOptionModel_ClassTransformType)
	allowed_status_options: GraduationReviewOptionModel[];
	@Type(GraduationReviewUpdateReasonsModel_ClassTransformType)
	update_reasons: GraduationReviewUpdateReasonsModel;
}

export class GraduationReviewRequestorModel {
	uid: number;
	name: string;
}

export function GraduationReviewRequestorModel_ClassTransformType() {
	return GraduationReviewRequestorModel;
}

export class GraduationReviewRequestChecklistModel {
	key: string;
	is_completed: boolean;
	@Transform(dateTransformer)
	completed_on: Date;
	@Type(GraduationReviewRequestorModel_ClassTransformType)
	completed_by: GraduationReviewRequestorModel;
}

export function GraduationReviewRequestChecklistModel_ClassTransformType() {
	return GraduationReviewRequestChecklistModel;
}

export class GradReviewFileModel {
	url: string;
	title: string;
}

export function GradReviewFileModel_ClassTransformType() {
	return GradReviewFileModel;
}

export class GraduationReviewRequestUpdateModel {
	id: number;
	is_current: boolean;
	@Type(GraduationReviewOptionModel_ClassTransformType)
	status: GraduationReviewOptionModel;
	@Transform(dateTransformer)
	created_on: Date;
	@Type(GraduationReviewRequestorModel_ClassTransformType)
	created_by: GraduationReviewRequestorModel;
	note: string;
	reasons: string[];
	@Type(GradReviewFileModel_ClassTransformType)
	files: GradReviewFileModel[];
}

export function GraduationReviewRequestUpdateModel_ClassTransformType() {
	return GraduationReviewRequestUpdateModel;
}

export class GraduationReviewRequestModel {
	id: number;
	is_completed: boolean;
	@Transform(dateTransformer)
	requested_on: Date;
	@Type(GraduationReviewRequestorModel_ClassTransformType)
	requested_by: GraduationReviewRequestorModel;
	@Transform(dateTransformer)
	last_updated_on: Date;
	@Type(GraduationReviewRequestChecklistModel_ClassTransformType)
	checklist: GraduationReviewRequestChecklistModel[];
	checklist_notes: string;
	@Type(GraduationReviewRequestUpdateModel_ClassTransformType)
	@Transform(calendarDateTransformer)
	college_deadline: Date;
	updates: GraduationReviewRequestUpdateModel[];
	@Type(StudentPauseRequestModel_ClassTransform_Type)
	pause_request: StudentPauseRequestModel;
	@Type(StudentWithdrawRequestModel_ClassTransformType)
	withdrawal_request: StudentWithdrawRequestModel;
}

export interface GradReviewUpdateArgument {
	note?: string;
	status?: GraduationReviewStatus;
	reasons?: string[]; // used for requirements only for status 3 currently
	college_deadline?: string;
	graduation_date?: string; // ex. '2024-05-15'
	pause_start?: number;
	scheduled_withdrawal_date?: string; // ex. '2024-05-15'
	create_pause?: boolean;
}

export interface GradReviewChecklistArgument {
	checklist_field: string;
	is_completed: boolean;
}

export interface GradReviewCreateArgument {
	college_deadline: string;
	reason: string;
}
